<template>
	<Transition appear name="fade-up">
		<div class="element-container">
			<!-- Add Tabs component here if we want it pinned at top -->
			<Transition appear name="fade-up-delayed">
				<ControlMVP/>
			</Transition>
		</div>
	</Transition>
</template>

<script setup>
import ControlMVP from './ControlMVP.vue'
</script>